"use client"

import { buildMetrixUrl, useMetrixLocale } from "@repo/ui/utils"
import Image from "next/image"
import Link from "next/link"

import GradientText from "../../../../GradientText"

/**
 * Metrix 链接组件
 */
export function MetalMindLink() {
  const metrixLocale = useMetrixLocale()

  return (
    <Link href={buildMetrixUrl("/", metrixLocale)} className="mobileNavItem aiLink" target="_blank">
      <Image src={`https://imgqn.smm.cn/static/image/metal/ai-logo.svg`} alt="logo" width={20} height={20} />
      <GradientText
        className="mobileAiText"
        colors={["#5227FF", "#FF9FFC", "#B19EEF"]}
        animationSpeed={4}
        showBorder={false}
      >
        Metrix
      </GradientText>
    </Link>
  )
}
